import { Utils } from './utils';
//namespace Pacem {
const EXPIRATION_FIELD = '_exp';
export class Storage {
    _getStorage(persistent) {
        return !!persistent ? window.localStorage : window.sessionStorage;
    }
    _parseValue(storage, name) {
        const value = storage.getItem(name);
        if (Utils.isNullOrEmpty(value)) {
            return null;
        }
        const output = Utils.Json.parse(value);
        if (!Object.hasOwnProperty(EXPIRATION_FIELD)) {
            return output;
        }
        const exp = output[EXPIRATION_FIELD];
        if (exp < Date.now()) {
            storage.removeItem(name);
            return null;
        }
        return output['value'];
    }
    setPropertyValue(name, value, persistent) {
        var storage = this._getStorage(persistent === true || (typeof persistent === 'number' && persistent > 0));
        var storedValue = value;
        // set cache timeout
        if (typeof persistent === 'number' && persistent > 0) {
            const exp = Date.now() + 1000 * persistent;
            storedValue = { value: value };
            storedValue[EXPIRATION_FIELD] = exp;
        }
        storage.setItem(name, Utils.Json.stringify(storedValue));
        // delete omonymy
        storage = this._getStorage(!persistent);
        storage.removeItem(name);
    }
    getPropertyValue(name) {
        return this._parseValue(this._getStorage(false), name)
            || this._parseValue(this._getStorage(true), name);
    }
    clear() {
        var storage = this._getStorage(true);
        storage.clear();
        storage = this._getStorage(false);
        storage.clear();
    }
    ;
    removeProperty(name) {
        var storage = this._getStorage(true);
        storage.removeItem(name);
        storage = this._getStorage(false);
        storage.removeItem(name);
    }
}
//}
